import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import axiosConn from 'config/axiosConn';
import { FaEye, FaEyeSlash } from "react-icons/fa";

const PasswordUpdate = () => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const navigate = useNavigate();

  const handlePasswordUpdate = async (e) => {
    e.preventDefault();
    
    if (password !== confirmPassword) {
      toast.error("Passwords do not match");
      return;
    }

    if (password.length < 8) {
      toast.error("Password must be at least 8 characters long");
      return;
    }

    setLoading(true);
    try {
      const response = await axiosConn('post', 'update-password', { password });
      
      if (response.data.success) {
        toast.success("Password updated successfully!");
        navigate("/school"); // Redirect to school dashboard
      } else {
        toast.error(response.data.message || "Failed to update password");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "An error occurred while updating password");
      console.error("Password update error:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mt-5 mb-20">
      <div className="row justify-content-center">
        <div className="col-md-6 mb-5">
          <div className="card">
            <div className="card-body">
              <h3 className="card-title text-center mb-4">Set Your Password</h3>
              <form onSubmit={handlePasswordUpdate}>
                <div className="form-group mb-3" style={{ position: 'relative' }}>
                  <label htmlFor="password">New Password</label>
                  <input
                    type={showPassword ? "text" : "password"}
                    className="form-control"
                    id="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    minLength="8"
                  />
                  <span
                    onClick={() => setShowPassword((v) => !v)}
                    style={{
                      position: 'absolute',
                      right: '12px',
                      bottom: '10px',
                      cursor: 'pointer',
                      zIndex: 10
                    }}
                    aria-label={showPassword ? "Hide password" : "Show password"}
                  >
                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                  </span>
                </div>
                <div className="form-group mb-4" style={{ position: 'relative' }}>
                  <label htmlFor="confirmPassword">Confirm Password</label>
                  <input
                    type={showConfirm ? "text" : "password"}
                    className="form-control"
                    id="confirmPassword"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    required
                    minLength="8"
                  />
                  <span
                    onClick={() => setShowConfirm((v) => !v)}
                    style={{
                      position: 'absolute',
                      right: '12px',
                      bottom: '10px',
                      cursor: 'pointer',
                      zIndex: 10
                    }}
                    aria-label={showConfirm ? "Hide password" : "Show password"}
                  >
                    {showConfirm ? <FaEyeSlash /> : <FaEye />}
                  </span>
                </div>
                <button 
                  type="submit" 
                  className="btn btn-primary w-100"
                  disabled={loading}
                >
                  {loading ? 'Updating...' : 'Update Password'}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PasswordUpdate;